import { GET } from '../../_http';
import type { operations } from '@/types/schemas/api.main';
type controller = operations['CustomerUserCurrentUserController_get'];

export type CustomerCurrentUserResponse = controller['responses']['200']['content']['application/json'];

export const currentUser = GET('/users/user/current-user')<CustomerCurrentUserResponse>;
